import React from 'react';
import { Form, FormInstance, Row } from 'antd';
import FormInput from 'components/FormInput';
import AssetUpload from 'components/AssetUpload';
import DF from 'DisplayFramework';
import Title from 'components/Title';

export type AssetCatalogPictursTableProps = {
  form: FormInstance;
  catalogid?: number;
};

const AssetCatalogPicturessTable = ({
  form,
  catalogid,
}: AssetCatalogPictursTableProps) => {
  return (
    <DF.Provider pagcode="assetCatalogPictures">
      <Title level={4} comcode="assetCatalogPictures" />

      <Form form={form} initialValues={INITIAL_VALUES}>
        <Row gutter={32}>
          <FormInput col xs={24} lg={8} onlylabel="assetpictureurl">
            <AssetUpload
              catalogid={catalogid}
              picid={1}
              name="assetpictureurl"
              form={form}
              objectreference=""
            />
          </FormInput>
          <FormInput col xs={24} lg={8} onlylabel="assetpictureurl2">
            <AssetUpload
              catalogid={catalogid}
              picid={2}
              name="assetpictureurl2"
              form={form}
              objectreference=""
            />
          </FormInput>
          <FormInput col xs={24} lg={8} onlylabel="assetpictureurl3">
            <AssetUpload
              catalogid={catalogid}
              picid={3}
              name="assetpictureurl3"
              form={form}
              objectreference=""
            />
          </FormInput>
        </Row>
        <Row gutter={32}>
          <FormInput col xs={24} lg={8} onlylabel="assetpictureurl4">
            <AssetUpload
              catalogid={catalogid}
              picid={4}
              name="assetpictureurl4"
              form={form}
              objectreference=""
            />
          </FormInput>
          <FormInput col xs={24} lg={8} onlylabel="assetpictureurl5">
            <AssetUpload
              catalogid={catalogid}
              picid={5}
              name="assetpictureurl5"
              form={form}
              objectreference=""
            />
          </FormInput>
          <FormInput col xs={24} lg={8} onlylabel="assetpictureurl6">
            <AssetUpload
              catalogid={catalogid}
              picid={6}
              name="assetpictureurl6"
              form={form}
              objectreference=""
            />
          </FormInput>
        </Row>
      </Form>
    </DF.Provider>
  );
};

const INITIAL_VALUES = {
  services: [],
};

export default AssetCatalogPicturessTable;
